import { connect } from 'react-redux';
import isEmpty from 'lodash.isempty';
import DemoControls from '../../../features/demoMode/reading/DemoModeHeader/DemoModeControls/DemoControls';
import { setDemoType, resetTour } from '../../../api/demoMode/reading/demoModeActions';
import { selectors } from '../../../root/reading/root';

const mapStateToProps = state => {
    return {
        isGuidedTourOn: selectors.getIsGuidedTourOn(state),
        demoType: selectors.getDemoType(state),
        visitedTourSteps: selectors.getVisitedTourSteps(state),
        isAllResultsFetched: isEmpty(selectors.getStudentIds(state))
            ? selectors.isDataFetched(state)
            : selectors.isResultDataFetched(state),
        activeStep: selectors.getActiveStep(state),
    };
};

const mapDispatchToProps = dispatch => ({
    defineDemoType: (newDemoType, isTourResumedOnSpecificSteps) => {
        dispatch(setDemoType(newDemoType, isTourResumedOnSpecificSteps));
    },
    resetTour: () => dispatch(resetTour()),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { activeStep } = stateProps;
    const { defineDemoType } = dispatchProps;
    const isTourResumedOnSpecificSteps = ['step-18', 'step-19', 'step-32', 'step-33'].includes(
        activeStep,
    );

    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        setDemoType: newDemoType => defineDemoType(newDemoType, isTourResumedOnSpecificSteps),
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(DemoControls);
